/** Lightweight analytics wrapper around the site's existing PostHog instance. */
export function track(event, props = {}) {
  try {
    if (typeof window !== "undefined" && window.posthog && typeof window.posthog.capture === "function") {
      window.posthog.capture(event, props);
    }
  } catch {
    /* analytics must never break the UI */
  }
}
